import {
    Building2,
    Calendar1,
    ChartArea,
    FileChartColumnIncreasing,
    Logs,
    Mail,
    Newspaper,
    NotebookPen,
    Settings,
    Star,
} from 'lucide-react'
import GridViewIcon from '@mui/icons-material/GridView'
import { DashboardBaseProps } from '../../layouts/DashboardBase'

const menuSection: DashboardBaseProps['dashboardItems'][number]['pages'] = [
    {
        href: '/overview',
        icon: GridViewIcon,
        titleI18n: 'site.nav.overview',
    },
    {
        href: '/news',
        icon: Newspaper,
        titleI18n: 'site.nav.news',
    },
    {
        href: '/calendar',
        icon: Calendar1,
        titleI18n: 'site.nav.calendar',
    },
    {
        href: '/issues',
        icon: Logs,
        titleI18n: 'site.nav.issues',
    },
    {
        href: '/statistics',
        icon: ChartArea,
        titleI18n: 'site.nav.statistics',
    },
    {
        href: '/warrants',
        icon: FileChartColumnIncreasing,
        titleI18n: 'site.nav.warrants',
    },
    {
        href: '/companies',
        icon: Building2,
        titleI18n: 'site.nav.companies',
    },
]

const settingsSection: DashboardBaseProps['dashboardItems'][number]['pages'] = [
    {
        href: '/profile',
        icon: Settings,
        titleI18n: 'site.nav.settingsSection',
    },
    {
        href: 'https://financelab.se',
        icon: Mail,
        titleI18n: 'site.nav.contact',
    },
]

const navItems: DashboardBaseProps['dashboardItems'] = [
    {
        titleI18n: 'site.nav.menuSection',
        pages: menuSection,
    },
    {
        titleI18n: 'site.nav.myPages',
        pages: [
            {
                href: '/watch-lists',
                icon: Star,
                titleI18n: 'site.nav.watchList',
            },
            {
                href: '/notes',
                icon: NotebookPen,
                titleI18n: 'site.nav.notes',
            },
        ],
    },
    {
        titleI18n: 'site.nav.support',
        pages: settingsSection,
    },
]

export { navItems }
